import { TrainerModel } from "../trainer.model";

export interface LearningPathCourseAddModel {
  learningPathId: string;
  eventId: string;
  parentId: string | null;
}

export interface LearningPathCourseModel {
  id: string;
  eventId: string;
  name: string;
  description: string;
  imageUrl: string;
  parentId: string | null;
  status: CoursePersonStatusModel;
  trainers: TrainerModel[];
  isNew: boolean;
}

export enum CoursePersonStatusModel
{
  None = 0,
  Open = 1,
  Closed = 2,
  Required = 3
}